import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp, faSortDown, faSort } from '@fortawesome/free-solid-svg-icons';

export interface SortPillProps {
  label: string;
  isActive: boolean | number;  // true/false or 1/-1 for direction
  onClick: () => void;
  ariaLabel?: string;
}

const SortPill: React.FC<SortPillProps> = ({ 
  label, 
  isActive, 
  onClick, 
  ariaLabel 
}) => {
  // Handle keyboard navigation
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div 
      role="button"
      tabIndex={0}
      className={`sort-pill d-flex align-items-center px-3 py-2 ${isActive !== false && isActive !== null ? 'sort-pill-active' : ''}`}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      aria-pressed={isActive !== false && isActive !== null}
      aria-label={ariaLabel || `Sort by ${label}`}
      aria-sort={isActive === 1 ? 'ascending' : isActive === -1 ? 'descending' : 'none'}
    >
      {label}
      <span className="ms-1">
        {isActive === false || isActive === null ? (
          <FontAwesomeIcon icon={faSort} size="sm" className="ms-1 text-muted" />
        ) : isActive === true || isActive === 1 ? (
          <FontAwesomeIcon icon={faSortUp} size="sm" className="ms-1" />
        ) : (
          <FontAwesomeIcon icon={faSortDown} size="sm" className="ms-1" />
        )}
      </span>
      <style>{`
        .sort-pill {
          border-radius: 20px;
          background: #f8f9fa;
          border: 1px solid #e9ecef;
          color: #495057;
          font-weight: 600;
          transition: all 0.2s ease-in-out;
          box-shadow: 0 1px 2px rgba(0,0,0,0.05);
          cursor: pointer;
          user-select: none;
          padding: 2px 0px;
          font-size: 12px;    
        } 
        
        .sort-pill:hover {
          background: #f1f3f5;
          box-shadow: 0 2px 4px rgba(0,0,0,0.08);
          transform: translateY(-1px);
        }
        
        .sort-pill:active {
          transform: translateY(0);
          box-shadow: 0 1px 2px rgba(0,0,0,0.05);
        }
        
        .sort-pill-active {
          background: linear-gradient(135deg, #ff9a3f, #ff7f00);
          color: white;
          border-color: #ff7f00;
          box-shadow: 0 2px 5px rgba(255,127,0,0.3);
        }
        
        .sort-pill-active:hover {
          background: linear-gradient(135deg, #ff8c2a, #ff7000);
          box-shadow: 0 3px 6px rgba(255,127,0,0.4);
        }
        
        .sort-pill:focus {
          outline: none;
          box-shadow: 0 0 0 3px rgba(255,127,0,0.25);
        }
      `}</style>
    </div>
  );
};

export default SortPill;
